import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {DynamicScriptLoaderService} from '../../../../services/dynamic-script-loader.service';
import {HttpClient} from '@angular/common/http';
import {isUndefined} from 'util';
import {EmojiModule} from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {NotifierWrapService} from '../../../../services/notifier-wrap.service';
import {Subject, Subscription, takeUntil} from 'rxjs';
import {TelegramService} from '../../../../pages/page-telegram/telegram.service';
import {IMessengerConnector, Message, MessageVoice} from '../../../../types/all.type';
import {InterfaceService} from '../../../../services/interface.service';


declare const GreenAudioPlayer: any;

@Component({
  selector: 'app-voice-player',
  templateUrl: './voice-player.component.html',
  styleUrls: ['./voice-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VoicePlayerComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @ViewChild('player') player: ElementRef;
  @Input() Service: IMessengerConnector;
  @Input() voice: MessageVoice;
  init = false;
  voiceText: string;
  isLoadText = false;
  @Input() message: Message;
  initTimeout: NodeJS.Timeout;

  constructor(
    public interfaceService: InterfaceService,
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    public dynamicScriptLoaderService: DynamicScriptLoaderService,
    private cdr: ChangeDetectorRef,
    public notifierWrapService: NotifierWrapService
  ) {
  }

  ngOnInit(): void {
    // this.cd.detach();
  }

  voicePlayerInit() {
    if (this.init) return;
    this.init = true;
    this.dynamicScriptLoaderService.loadStyle(
      '/assets/js/green-audio-player/css/green-audio-player.min.css',
      'green-audio'
    );
    this.dynamicScriptLoaderService.load(['green-player']).then(() => {
      // this.cd.detectChanges();
      if (!this.voice.file_uri) {
        if (this.Service instanceof TelegramService) {
          this.Service.loadAttachment$(this.voice).pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.cd.detectChanges();
            this.playerInit();
            console.log('voicePlayerInit:loadAttachment$', res, this.Service.type);
          })
        }
      } else {
        this.playerInit();
      }
    });
  }

  playerInit() {
    try {
      new GreenAudioPlayer(this.player.nativeElement, {
        selector: this.player.nativeElement,
        stopOthersOnPlay: true
      });
    } catch (e) {
      this.initTimeout = setTimeout(() => {
        this.dynamicScriptLoaderService.load(['green-player']).then(() => {
          this.playerInit();
        });
        console.error('Circular player init!');
      }, 3000);
    }
  }

  recognitionAudio() {
    this.isLoadText = true;
    this.cd.detectChanges();
    // TODO указать общий адрес севрера
    this.voice.uri = this.voice.file_uri.replace(/^.*\/\/[^\/]+/, '');
    this.http.get(`${this.Service.urlApi}/api/recognition/?file_uri=${this.voice.uri}`).subscribe(
      (result: any) => {
        if (!isUndefined(result.text)) {
          this.voiceText = result.text;
        } else if (!isUndefined(result.error)) {
          this.notifierWrapService.notify('error', result.error);
        }
        this.isLoadText = false;
        this.cd.detectChanges();
      },
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    clearTimeout(this.initTimeout);
  }
}
